import React from 'react'
import styles from './divider.module.css'

export const SectionDivider = () => {
  return (
    <div className={styles.divider}>
      <div className={styles.line} />
    </div>
  )
}